export default "__VITE_ASSET__CxYyTcp2__"